import React, { useEffect } from "react";
import "./MixedFeelings.css";
import { Scrolly } from "./components/scrolly";
import { useNavigate } from "react-router-dom";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";

import TEXT from "../../utils/text/prensa.json";

export default function MixedFeelings() {
  const navigate = useNavigate();

  const { language } = useCurrentLanguage();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  const onDashboardClick = () => {
    // push route to /#/prensa/LAC
    console.log("Navigate to dashboard");
    console.log("Language", language);
    if (language === "es") {
      navigate("/prensa/LAC");
    } else {
      navigate(`/${language}/prensa/LAC`);
    }
  };
  return (
    <div className="w-screen antialiased">
      <main className="">
        <div className="h-[80vh] px-4 text-center flex flex-col justify-center font-semibold">
          <h1 className="uppercase text-4xl	md:text-6xl !text-dark-blue">
            {TEXT["mixed_feelings"][language]}
          </h1>
          <div className="text-blue text-[40px] my-10">{"><"}</div>
          <p className="text-2xl md:text-3xl md:w-1/2 mx-auto !text-dark-blue">
            {TEXT["mixed_feelings"]["sub_1"][language]}
          </p>
          <div className="px-4 mx-auto flex gap-4 mt-12 flex-wrap justify-center pb-16">
            <button
              className="rounded-20 text-lg md:text-xl bg-blue hover:bg-dark-blue text-white uppercase px-6 py-4 font-semibold"
              onClick={onDashboardClick}
            >
              {
                TEXT["mixed_feelings"]["buttonSec"]["button_dashboard"][
                  language
                ]
              }
            </button>
           {/*  <button className="rounded-20 text-lg md:text-xl bg-dark-blue hover:bg-blue text-white uppercase px-6 py-4 font-semibold">
              {TEXT["mixed_feelings"]["buttonSec"]["download"][language]}
            </button> */}
          </div>
        </div>
        <Scrolly />
        <div className=" bg-white pt-48 text-2xl	md:text-3xl ">
          <p className="w-full px-4 md:w-1/2 text-dark-blue mx-auto text-center font-semibold whitespace-pre-line">
            {TEXT["mixed_feelings"]["buttonSec"]["title"][language]}
          </p>
          <div className="px-4 mx-auto flex gap-4 mt-12 flex-wrap justify-center pb-16">
            <button
              className="rounded-20 text-lg md:text-xl bg-blue hover:bg-dark-blue text-white uppercase px-6 py-4 font-semibold"
              onClick={onDashboardClick}
            >
              {
                TEXT["mixed_feelings"]["buttonSec"]["button_dashboard"][
                  language
                ]
              }
            </button>
           {/*  <button className="rounded-20 text-lg md:text-xl bg-dark-blue hover:bg-blue text-white uppercase px-6 py-4 font-semibold">
              {TEXT["mixed_feelings"]["buttonSec"]["download"][language]}
            </button> */}
          </div>
        </div>
      </main>
    </div>
  );

  // return <div>MixedFeelings</div>;
}
